export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id=" arrow_style06/down">
<path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M15.9999 16.7029L19.9514 12.7515L21.6484 14.4485L15.9999 20.097L10.3514 14.4485L12.0484 12.7515L15.9999 16.7029Z"/>
</g>
</svg>
